import React from 'react'
import MaxWidthWrapper from '../wrappers/MaxWidthWrapper';
import { Link, useLocation } from 'react-router-dom';
import QuestionnaireSelect from '../subcomponents/questionnaire/QuestionnaireSelect';
const MainLayout = ({ children }: { children: React.ReactNode }) => {
  const path = useLocation().pathname.split('/')[3];
  const questCode = useLocation().pathname.split('/')[2];

  return (
    <MaxWidthWrapper>
      <div className='imm_quest_admin__main_layout'>
        <QuestionnaireSelect />
        <div className='nav'>
          <Link to={`/questionnaire/${questCode}/questions`} className={`${path === 'questions' ? 'main_layout__select_nav' : ''}`}>Questions</Link>
          <Link to={`/questionnaire/${questCode}/criterias`} className={`${path === 'criterias' ? 'main_layout__select_nav' : ''}`}>Criteria</Link>
          <Link to={`/questionnaire/${questCode}/options`} className={`${path === 'options' ? 'main_layout__select_nav' : ''}`}>Options</Link>
          <Link to={`/questionnaire/${questCode}/repeats`} className={`${path === 'repeats' ? 'main_layout__select_nav' : ''}`}>Repeats</Link>
        </div>
        {children}
      </div>
    </MaxWidthWrapper>
  );
};

export default MainLayout;